module.exports = __webpack_public_path__ + "img/manual.844a3158.png";